import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { popupAjaxError } from "discourse/lib/ajax-error";
import DButton from "discourse/ui-kit/d-button";

export default class ChatDirectMessageButton extends Component {
  @service chat;
  @service appEvents;
  @service router;

  get shouldRender() {
    return this.chat.userCanDirectMessage;
  }

  @action
  async startChatting() {
    try {
      const channel = await this.chat.upsertDmChannel({
        usernames: [this.args.user.username],
      });

      if (channel) {
        this.router.transitionTo("chat.channel", ...channel.routeModels);
      }
    } catch (error) {
      popupAjaxError(error);
    } finally {
      if (this.args.modal) {
        this.appEvents.trigger("card:close");
      }
    }
  }

  <template>
    {{#if this.shouldRender}}
      <DButton
        class="btn-primary chat-direct-message-btn"
        @action={{this.startChatting}}
        @icon="d-chat"
        @label="chat.title_capitalized"
      />
    {{/if}}
  </template>
}
